import { render, staticRenderFns } from "./InfoCoberturas.vue?vue&type=template&id=19d1a21c&"
import script from "./InfoCoberturas.vue?vue&type=script&lang=js&"
export * from "./InfoCoberturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports